const MuiToggleButtonGroup = {
  defaultProps: {
    color: "primary"
  }
};
export {
  MuiToggleButtonGroup
};
//# sourceMappingURL=MuiToggleButtonGroup.js.map
